// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ExtractedSituation" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { SituationIssueGenShape } from "./situation-issue.gen";

export const ExtractedSituationGenShape = z.strictObject({
  tenure: z.string().optional(),
  confidence: z.number(),
  clarifierQuestion: z.string().optional(),
  issues: z.array(SituationIssueGenShape),
});
